module.exports = "/assets/1089efbc2cd04e7d82bad8556e494c35.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/J5.png
// module id = 2622
// module chunks = 0